import { useDispatch, useSelector } from 'react-redux'
import { Checkbox } from '../../common/html/checkbox'
import { changeSetting, selectCellDataById } from '../store/slice'
import { postUserNotificationSettings } from '../store/thunk'

const EmailCell = ({ checked, rowId, colId }) => {
  const dispatch = useDispatch()

  const dataRow = useSelector(selectCellDataById(rowId))

  const updateSetting = (enable) => {
    dispatch(
      postUserNotificationSettings({
        notificationTypeId: rowId,
        receiveNotification: dataRow.receiveNotification,
        receiveEmail: enable,
      }),
    )
      .unwrap()
      .then(() => {
        dispatch(
          changeSetting({
            rowId,
            keySetting: colId,
            newSetting: !checked,
          }),
        )
      })
      .catch(() => {})
  }

  return (
    <div className="dFlex justifyContentCenter" style={{ color: '#2C73E8' }}>
      <Checkbox
        onChange={updateSetting}
        styleIcon={{ fontSize: 12 }}
        checked={checked}
        allowChange={dataRow?.receiveNotification}
      />
    </div>
  )
}

export default EmailCell
